export function getUserStatusCode(str) {
  let result = ''
  switch (str) {
    case 1:
      result = '正常'
      break
    case 2:
      result = '待審核'
      break
    case 3:
      result = '已違規'
      break
    case 4:
      result = '已解禁'
      break
    case 5:
      result = '置頂'
      break
  }
  return result
}
export function getStatusHide(str){
  let result = ''
  switch(str) {
    case 0:
      result = '正常'
      break
    case 1:
      result = '黑名單'
      break
    case 2:
      result = '違規'
      break
    case 3:
      result = '敏感字符'
      break
    case -1:
      result = '已刪除'
      break
  }
  return result
}
export function getUserStatus(str) {
  let result = ''
  switch (str) {
    case '正常':
      result = 1
      break
    case '待審核':
      result = 2
      break
    case '已違規':
      result = 3
      break
    case '已解禁':
      result = 4
      break
    case '置頂':
      result = 5
      break
  }
  return result
}



// WEBPACK FOOTER //
// ./src/utils/getUserStatus.js